<template>
    <div class="mb-5 mt-5 p-5 bg-white rounded-xl shadow">
        <h3 class="text-xl font-bold">Convertir a factura</h3>
        <form @submit.prevent="submit">
            <div class="mb-2">
                <textarea-input v-model="form.comentary" label="Observación (*)" placeholder="Indica la modalidad de transporte o cualquier otro dato adicional"></textarea-input> 
                <select-input label="Modalidad" v-model="form.isCredit">
                    <option value="">Seleccionar</option>
                    <option :value="false">De contado</option>
                    <option :value="true">Crédito</option>
                </select-input>
                <div v-if="!form.isCredit" class="my-2">
                    <input v-model="form.discount" type="checkbox">
                    <label for=""> Aplicar decuento por pago inmediato y en efectivo</label>
                </div>
            </div>
            <loading-button :loading="form.processing" class="btn-blue" type="submit">Convertir a factura</loading-button>
        </form>
    </div>
</template>

<script>
import LoadingButton from './LoadingButton.vue'
import SelectInput from './SelectInput.vue'
import TextareaInput from './TextareaInput.vue'
import TextInput from './TextInput.vue'
export default {
  components: { TextInput, TextareaInput, LoadingButton, SelectInput },
    // En este componente, se podrá cambiar a los diferentes estatus, pero por ahora vamos a pasar de presupuesto a de contado
    props: {
        order: Object
    },  
    data()
    {
        return {
            form : this.$inertia.form({
                comentary: '',
                order_id: this.order.id,
                isCredit: false,
                discount: false
            })
        }
    },
    methods: {
        submit() {
            this.form.post('/orders/invoice');
        }
    }
}
</script>